import { useEffect, useMemo, useState } from "react";

import type { TableControlsFooterProps } from "./TableControlsFooter";

export function useClientPagination<T>(
  rows: T[],
  {
    initialPageSize = 10,
    resetKey,
  }: { initialPageSize?: number; resetKey?: unknown } = {}
): {
  paged: T[];
  tableControls: TableControlsFooterProps;
} {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(initialPageSize);

  useEffect(() => {
    setCurrentPage(1);
  }, [resetKey]);

  const total = rows.length;
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(currentPage, pages);

  const paged = useMemo(() => {
    const start = (safePage - 1) * pageSize;
    return rows.slice(start, start + pageSize);
  }, [rows, safePage, pageSize]);

  return {
    paged,
    tableControls: {
      currentPage: safePage,
      setCurrentPage,
      pageSize,
      onPageSizeChange: (opt) => {
        setPageSize(Number(opt.value));
        setCurrentPage(1);
      },
      data: { total, pages, items: paged },
    },
  };
}
